import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const budgetService = {
  getAll,
  createOrUpdate,
  deleteBudget
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/budgets/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newBudget) {
  const requestOptions = {
    method: newBudget.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newBudget)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/budgets${
    newBudget.id ? `/${newBudget.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(budget) {
  let formData = new FormData();

  formData.append('budget[title]', budget.title);
  formData.append('budget[date]', budget.date);
  const document = budget.document;

  if (document) {
    if (document.url) {
      formData.append(`budget[document]`, document.url);
    } else {
      formData.append(`budget[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteBudget(budgetId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/budgets/${budgetId}`;

  return axios.delete(url, requestOptionsDelete);
}
